"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConsentConfigurationBuilder = void 0;
class ConsentConfigurationBuilder {
    constructor(serviceConfigProvider, localeService) {
        this.serviceConfigProvider = serviceConfigProvider;
        this.localeService = localeService;
    }
    getConfiguration() {
        var _a;
        const consentCustomConfig = (_a = this.serviceConfigProvider.configs.consent) === null || _a === void 0 ? void 0 : _a.customConfig;
        if (!consentCustomConfig
            || !consentCustomConfig.appName
            || !consentCustomConfig.termsAndConditionsTextId
            || !consentCustomConfig.privacyStatementTextId) {
            throw new Error('Consent configuration is missing or incomplete');
        }
        return {
            consentEndpoint: this.serviceConfigProvider.configs.consent.urlOrigin,
            appName: consentCustomConfig.appName,
            termsAndConditionsTextId: consentCustomConfig.termsAndConditionsTextId,
            privacyStatementTextId: consentCustomConfig.privacyStatementTextId,
            countryCode: this.localeService.countryCode,
            language: this.localeService.language
        };
    }
}
exports.ConsentConfigurationBuilder = ConsentConfigurationBuilder;
//# sourceMappingURL=ConsentConfigurationBuilder.js.map